export default {"src":"//prod.smassets.net/assets/smweb/_next/static/media/msg-icon-white.8ce09d2b.svg","height":73,"width":97,"blurWidth":0,"blurHeight":0};